import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ClientBaseApi } from '../api/clientBase.api';
import { LocalStorageService } from '../storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class CsrfService extends ClientBaseApi {
  private readonly localStorage = inject(LocalStorageService);
  private readonly csrfTokenStorageKey = 'csrfToken';

  public initCsrf(apiURL: string) {
    return firstValueFrom(
      this.getData<{ csrfToken?: string; token?: string } | string>(
        apiURL + 'api/auth/csrf-token',
      ),
    ).then((response) => {
      const csrfToken = this.extractCsrfToken(response);

      if (csrfToken) {
        this.setCsrfToken(csrfToken);
      }

      return response;
    });
  }

  public getCsrfToken(): string | null {
    return this.localStorage.getItem(this.csrfTokenStorageKey);
  }

  public setCsrfToken(token: string): void {
    this.localStorage.setItem(this.csrfTokenStorageKey, token);
  }

  public clearCsrfToken(): void {
    this.localStorage.removeItem(this.csrfTokenStorageKey);
  }

  private extractCsrfToken(
    response: { csrfToken?: string; token?: string } | string,
  ): string | null {
    if (typeof response === 'string') {
      return response;
    }

    return response.csrfToken ?? response.token ?? null;
  }
}
